import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon, FilterIcon } from "@heroicons/react/outline";
import { Fragment } from "react";
import CreditsFilter from "./CreditsFilter";
import TopicsFilter from "./TopicsFilter";

const Filters = () => {
  return (
    <div className="tw-flex tw-items-center">
      <Popover className="tw-relative">
        <>
          <Popover.Button>
            <div
              className={`tw-text-white tw-group tw-bg-[#B5B5B7]/30 tw-px-3 tw-py-2 tw-rounded-md tw-items-center tw-justify-between tw-text-base tw-font-medium tw-w-40 tw-hidden md:tw-inline-flex tw-select-none`}
            >
              <span>Filters</span>
              <ChevronDownIcon
                className={`tw-ml-2 tw-h-5 tw-w-5 tw-text-white group-hover:tw-text-opacity-80 tw-transition tw-ease-in-out tw-duration-150`}
                aria-hidden="true"
              />
            </div>
            <FilterIcon className="tw-h-6 tw-w-6 md:tw-hidden tw-text-white" />
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="tw-transition tw-ease-out tw-duration-200"
            enterFrom="tw-opacity-0 tw-translate-y-1"
            enterTo="tw-opacity-100 tw-translate-y-0"
            leave="tw-transition tw-ease-in tw-duration-150"
            leaveFrom="tw-opacity-100 tw-translate-y-0"
            leaveTo="tw-opacity-0 tw-translate-y-1"
          >
            <Popover.Panel className="tw-absolute tw-z-10 tw-mt-3 tw-right-0">
              <div className="tw-overflow-hidden tw-rounded-lg tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-bg-white tw-py-6 tw-px-6 tw-w-screen tw-max-w-[290px] md:tw-max-w-sm tw-flex tw-flex-col tw-space-y-10">
                <TopicsFilter />
                <CreditsFilter />
              </div>
            </Popover.Panel>
          </Transition>
        </>
      </Popover>
    </div>
  );
};

export default Filters;
